<div class="mt-4">
  <!-- Add Testimonial Button -->
  <div class="d-flex align-items-center justify-content-between">
    <button class="btn btn-primary mb-3" data-bs-toggle="modal" data-bs-target="#testimonialModal" (click)="resetForm()">
      <i class="fas fa-plus"></i> Erfahrungsbericht hinzufügen
    </button>
  </div>

  <!-- Testimonials Table -->
  <div class="table-responsive always-scroll">
    <table class="table table-striped align-middle dashboard-table">
      <thead>
        <tr>
          <th>Bild</th>
          <th>Autor</th>
          <th>Position</th>
          <th>Inhalt</th>
          <th>Bewertung</th>
          <th>Aktionen</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let testimonial of testimonials" class="testimonial-row">
          <td class="image-col">
            <img *ngIf="testimonial.image" [src]="testimonial.image" loading="lazy" alt="Vorschau" class="img-thumbnail" style="width: 60px; height: 60px;">
          </td>
          <td class="author-col">
            <span class="text-lg-wrap text-lg-break">{{ testimonial.author }}</span>
          </td>
          <td class="position-col">
            <span class="text-lg-wrap text-lg-break">{{ testimonial.position }}</span>
          </td>
          <td class="content-col">
            <span class="text-lg-wrap text-lg-break" [title]="testimonial.content">{{ testimonial.content | slice:0:50 }}{{ testimonial.content.length > 50 ? '...' : '' }}</span>
          </td>
          <td class="rating-col">
            {{ testimonial.rating }} / 5
          </td>
          <td class="actions-col">
            <button class="btn btn-warning btn-sm me-2" (click)="editTestimonial(testimonial)">
              <i class="fas fa-edit"></i>
            </button>
            <button class="btn btn-danger btn-sm me-2" (click)="deleteTestimonial(testimonial.id!)">
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="testimonials.length === 0 && showSpinner==false" style="text-align: center;">
          <td colspan="6" class="text-muted">Keine Erfahrungsberichte verfügbar</td>
        </tr>
        <tr *ngIf="showSpinner" style="text-align: center;">
          <td colspan="6">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Lädt...</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Add/Edit Testimonial Modal -->
<div class="modal fade" id="testimonialModal" tabindex="-1" aria-labelledby="testimonialModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <form #testimonialForm="ngForm" (ngSubmit)="saveTestimonial(testimonialForm)">
        <div class="modal-header">
          <h5 class="modal-title" id="testimonialModalLabel">{{ editMode ? 'Erfahrungsbericht bearbeiten' : 'Erfahrungsbericht hinzufügen' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <!-- Author -->
          <div class="mb-3">
            <label>Autor <span class="text-danger">*</span></label>
            <input type="text" 
                   class="form-control"
                   name="author" 
                   [(ngModel)]="currentTestimonial.author" 
                   #author="ngModel" 
                   required
                   minlength="3">
            <div *ngIf="author.invalid && author.touched" class="text-danger small">
              <div *ngIf="author.errors?.['required']">Autor ist erforderlich</div>
              <div *ngIf="author.errors?.['minlength']">Autor muss mindestens 3 Zeichen lang sein</div>
            </div>
          </div>

          <!-- Position -->
          <div class="mb-3">
            <label>Position <span class="text-danger">*</span></label>
            <input type="text" 
                   class="form-control"
                   name="position" 
                   [(ngModel)]="currentTestimonial.position" 
                   #position="ngModel" 
                   required
                   minlength="3">
            <div *ngIf="position.invalid && position.touched" class="text-danger small">
              <div *ngIf="position.errors?.['required']">Position ist erforderlich</div>
              <div *ngIf="position.errors?.['minlength']">Position muss mindestens 3 Zeichen lang sein</div>
            </div>
          </div>

          <!-- Content -->
          <div class="mb-3">
            <label>Inhalt <span class="text-danger">*</span></label>
            <textarea class="form-control"
                      name="content" 
                      [(ngModel)]="currentTestimonial.content" 
                      #content="ngModel" 
                      required
                      rows="5"
                      minlength="5"></textarea>
            <div *ngIf="content.invalid && content.touched" class="text-danger small">
              <div *ngIf="content.errors?.['required']">Inhalt ist erforderlich</div>
              <div *ngIf="content.errors?.['minlength']">Inhalt muss mindestens 5 Zeichen lang sein</div>
            </div>
          </div>

          <!-- Rating -->
          <div class="mb-3">
            <label>Bewertung <span class="text-danger">*</span></label>
            <input type="number" 
                   class="form-control"
                   name="rating" 
                   [(ngModel)]="currentTestimonial.rating" 
                   #rating="ngModel" 
                   required
                   min="1"
                   max="5">
            <div *ngIf="rating.invalid && rating.touched" class="text-danger small">
              <div *ngIf="rating.errors?.['required']">Bewertung ist erforderlich</div>
              <div *ngIf="rating.errors?.['min'] || rating.errors?.['max']">Bewertung muss zwischen 1 und 5 liegen</div>
            </div>
          </div>

          <!-- Image Upload -->
          <div class="mb-3">
            <label>Bild</label>
            <input type="file" class="form-control" (change)="onFileSelected($event)">
            <div *ngIf="currentTestimonial.image" class="mt-2">
              <img [src]="currentTestimonial.image" loading="lazy" alt="Vorschau" class="img-thumbnail" style="width: 100px; height: 100px;">
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Abbrechen</button>
          <button type="submit" class="btn btn-success" [disabled]="testimonialForm.invalid" data-bs-dismiss="modal">
            <i class="fas fa-save"></i> {{ editMode ? 'Aktualisieren' : 'Speichern' }}
          </button>
        </div>
      </form>
    </div>
  </div> 
</div>